import { motion } from "framer-motion";
import Marquee from "react-fast-marquee";

const rowA = ["BAFTA", "SHELL", "FERRARI", "F1", "BBC", "DELIVEROO", "LINKEDIN", "WEST HAM UNITED"];
const rowB = ["BT", "AMAZON PRIME VIDEO", "AMEX", "EE", "GOV.UK", "MAJESTIC WINES", "UNIVERSITY OF ESSEX", "BARKING & DAGENHAM"];

const Row = ({ items, direction, testId }) => (
  <Marquee speed={28} direction={direction} autoFill gradient={false} pauseOnHover data-testid={testId}>
    {items.map((c) => (
      <span key={c} className="font-display uppercase text-6xl sm:text-7xl lg:text-8xl text-outline mx-8 whitespace-nowrap cursor-default">
        {c}
        <span className="text-[#E80042] mx-8" style={{ WebkitTextStroke: 0 }}>✦</span>
      </span>
    ))}
  </Marquee>
);

export const ClientWall = () => (
  <section id="work" className="py-24 sm:py-32 overflow-hidden" data-testid="client-wall-section">
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7 }}
      className="max-w-[1600px] mx-auto px-6 lg:px-12 mb-14 flex items-end justify-between gap-6"
    >
      <div>
        <p className="text-sm uppercase tracking-[0.3em] font-semibold text-[#E80042] mb-4">01 — The Company We Keep</p>
        <h2 className="font-grotesk font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-none">
          Big names.<br />Bigger stories.
        </h2>
      </div>
      <p className="hidden md:block max-w-xs text-[#555555] text-base leading-relaxed">
        Our team has delivered production for some of the biggest brands on the planet.
      </p>
    </motion.div>
    <div className="space-y-4 -rotate-1">
      <Row items={rowA} direction="left" testId="client-marquee-row-1" />
      <Row items={rowB} direction="right" testId="client-marquee-row-2" />
    </div>
  </section>
);
